import SCRIPT_TYPE from "enums/SCRIPT_TYPE";
import { useMemo } from "react";
import { COMPLETED_STATUSES } from "types/ParticipantCompletedStatuses";
import useGetParticipants from "./api/useGetParticipants";

interface Params {
  scriptId?: string;
}

export default function useGetParticipantCompletion(params?: Params) {
  const { participants } = useGetParticipants();
  const { scriptId } = params || {};

  return useMemo(() => {
    let moderatedCompleted = 0;
    let mobileCompleted = 0;

    participants?.forEach((participant) => {
      participant.scripts.forEach(({ id, participantStatus, scriptType }) => {
        if (scriptId && id !== scriptId) return;
        if (
          participantStatus &&
          COMPLETED_STATUSES.includes(participantStatus)
        ) {
          if (scriptType === SCRIPT_TYPE.MOBILE) mobileCompleted++;
          else if (scriptType === SCRIPT_TYPE.MODERATED) moderatedCompleted++;
        }
      });
    });

    return { moderatedCompleted, mobileCompleted };
  }, [participants]);
}
